import { render, staticRenderFns } from "./DataMemoryMapping.vue?vue&type=template&id=582f14c2&scoped=true&"
import script from "./DataMemoryMapping.vue?vue&type=script&lang=js&"
export * from "./DataMemoryMapping.vue?vue&type=script&lang=js&"
import style0 from "./DataMemoryMapping.vue?vue&type=style&index=0&id=582f14c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f14c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VForm,
  VTextField,
})
